import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Menu,
  Select,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import {
  IconCaretDown,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileUpload,
  IconPlus,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDebouncedState, useDebouncedValue } from "@mantine/hooks";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import {
  _timerDelayClick,
  repositoryDelivery,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMBranch } from "../../../../model/TblDMBranch";
import "../tab.component.css";
import "../../../../Styles/compact-table-head.css";
import CreateDataView from "./CreateDataView";
import DetailDataView from "./DetailDataView";
import EditDataView from "./EditDataView";
import ImportExcelView from "./ImportExcelView";

const DMBranch = () => {
  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<TblDMBranch>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "name",
        header: "Tên chi nhánh",
      },
      {
        accessorKey: "channelcode",
        header: "Mã chi nhánh Asia",
        size: 170,
      },
      {
        accessorKey: "companyCode",
        header: "Công ty",
        size: 130,
        filterFn: "equals",
        mantineFilterSelectProps: {
          data: [
            { label: "HACOM", value: "HACOM" },
            { label: "DVT", value: "DVT" },
          ],
        },
        filterVariant: "select",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="light"
              color={renderedCellValue === "DVT" ? "teal" : "blue"}
            >
              {renderedCellValue}
            </Badge>
          ) : null,
      },

      {
        accessorKey: "isonline",
        header: "Sử dụng",
        size: 130,
        Cell: ({ row }) => (
          <Badge
            radius="sm"
            variant="light"
            color={Number((row.original as any)?.isonline) === 1 ? "teal" : "red"}
          >
            {Number((row.original as any)?.isonline) === 1
              ? "Đang sử dụng"
              : "Dừng sử dụng"}
          </Badge>
        ),
      },

      // {
      //   accessorKey: "address",
      //   header: "Địa chỉ cũ",
      //   size: 425,
      // },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        size: 425,
      },
      {
        accessorKey: "attribute1",
        header: "SĐT bảo hành",
      },
      {
        accessorKey: "attribute2",
        header: "STT",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 130,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            {/* <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  await deletesData([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
          </Box>
        ),
      },
    ],
    []
  );

  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMBranch[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDMBranch[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  //table state

  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [keySearch, setKeySearch] = useDebouncedState<string>("", 300);
  // tìm kiếm / lọc phía client vì api get-all trả về toàn bộ chi nhánh
  const [searchText, setSearchText] = useState<string>("");
  const [debouncedSearchText] = useDebouncedValue(searchText, 300);
  const [companyCodeFilter, setCompanyCodeFilter] = useState<string | null>(
    null
  );
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleExport = () => {
    try {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-danh-muc-trung-tam.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    try {
      const response = await repositoryDelivery.get<
        MessageResponse<TblDMBranch[]>
      >("/api/v1/TblDmMasterOrg/get-all");

      if (response && response.success) {
        let result = response.data;
        setData(result);
        setDataTemp(response.data);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
        setDataTemp([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setRowCount(0);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm mới chi nhánh !</Title>
        </>
      ),
      centered: true,
      size: "650px",
      children: <CreateDataView onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa chi nhánh !</Title>
        </>
      ),
      centered: true,
      size: "650px",
      children: <EditDataView id={id} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function detailItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết chi nhánh !</Title>
        </>
      ),
      centered: true,
      size: "650px",
      children: <DetailDataView id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function importExcelItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Import excel danh mục chi nhánh !</Title>
        </>
      ),
      size: "auto",
      yOffset: "3%",
      children: <ImportExcelView onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const kw = debouncedSearchText.trim().toLowerCase();
    let result: any[] = dataTemp;
    if (companyCodeFilter)
      result = result.filter(
        (x: any) => String(x?.companyCode ?? "") === companyCodeFilter
      );
    if (activeFilter)
      result = result.filter((x: any) =>
        activeFilter === "1"
          ? Number(x?.isonline) === 1
          : Number(x?.isonline) !== 1
      );
    if (kw)
      result = result.filter((x: any) =>
        [x?.code, x?.name, x?.channelcode, x?.channelCode, x?.address, x?.attribute1]
          .some((f) => String(f ?? "").toLowerCase().includes(kw))
      );
    setData(result);
    setRowCount(result.length);
    setSelectIds([]);
    table.resetRowSelection();
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchText, companyCodeFilter, activeFilter, dataTemp]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus]);

  useEffect(() => {
    const handleResize = () => {
      const rect = headerRef.current?.getBoundingClientRect();
      const top = rect?.top ?? 0;
      const headerHeight = rect?.height ?? 0;
      // 120 = thanh phân trang + thanh cuộn ngang + padding dưới
      setHeight(
        Math.max(window.innerHeight - top - headerHeight - 120, 220)
      );
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // danh sách công ty lấy từ dữ liệu thực tế, tránh hard-code
  const companyCodeOptions = React.useMemo(() => {
    const codes = Array.from(
      new Set(
        dataTemp
          .map((x: any) => String(x?.companyCode ?? "").trim())
          .filter((x) => x.length > 0)
      )
    ).sort();
    return codes.map((x) => ({ label: x, value: x }));
  }, [dataTemp]);

  const isFiltering = Boolean(searchText || companyCodeFilter || activeFilter);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex align={"center"} gap={"md"} wrap={"wrap"}>
          <TextInput
            size="sm"
            style={{ flex: 1, minWidth: 220, maxWidth: 260 }}
            placeholder="Mã, tên, mã Asia, địa chỉ, SĐT"
            leftSection={<IconSearch size={20} color="#15aabf" />}
            value={searchText}
            onChange={(e) => setSearchText(e.currentTarget.value)}
            rightSection={
              searchText ? (
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  onClick={() => setSearchText("")}
                >
                  <IconX size={16} />
                </ActionIcon>
              ) : null
            }
          />
          <Select
            size="sm"
            style={{ maxWidth: 160 }}
            placeholder="Công ty"
            clearable
            searchable
            data={companyCodeOptions}
            value={companyCodeFilter}
            onChange={setCompanyCodeFilter}
          />
          <Select
            size="sm"
            style={{ maxWidth: 170 }}
            placeholder="Trạng thái"
            clearable
            data={[
              { label: "Đang sử dụng", value: "1" },
              { label: "Dừng sử dụng", value: "0" },
            ]}
            value={activeFilter}
            onChange={setActiveFilter}
          />
          {isFiltering ? (
            <Button
              variant="subtle"
              color="gray"
              size="sm"
              leftSection={<IconX size={14} />}
              onClick={() => {
                setSearchText("");
                setCompanyCodeFilter(null);
                setActiveFilter(null);
              }}
            >
              Xóa lọc
            </Button>
          ) : null}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <Flex align={"center"} gap={"md"}>
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                createItem();
              }}
            >
              Thêm mới
            </Button>
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={importExcelItem}
                >
                  Import Excel
                </Menu.Item>

                <Menu.Item
                  leftSection={
                    <IconX style={{ width: rem(14), height: rem(14) }} />
                  }
                >
                  Đóng
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
      </>
    ),

    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableHeadCellProps: {
      style: {
        padding: "2px 15px",
        fontSize: "12.5px",
        fontWeight: 600,
      },
    },
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
      className: "compact-table-head",
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  //#endregion
  return (
    <>
      <MantineReactTable table={table} />
    </>
  );
};
export default DMBranch;
